import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Material-UI
import { makeStyles } from 'tss-react/mui';

// React-Bootstrap
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'

const useStyles = makeStyles()({
  docList: {
    marginLeft: '32px',
    '& > div': {
      marginBottom: '15px',
    }
  },
});

// if defined cui_uri takes precedence over uri when in CUI runtime
let docs = {
  helpDoc: {
    name: 'helpDoc',
    uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-user-guide.pdf',
    cui_uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/agent-user-guide.pdf'
  },
  ddValidationDoc: {
    name: 'ddValidationDoc',
    uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-validation-guide.pdf'
  },
  wearableDDEx: {
    name: 'wearableDDEx',
    uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-wearable-dd-example.csv'
  },
  surveyDDEx: {
    name: 'surveyDDEx',
    uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-survey-dd-example.csv'
  },
  harmonizedDDEx: {
    name: 'harmonizedDDEx',
    uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/rapids-harmony-dd.csv'
  },
  dlhelp0: {
    name: 'download package help',
    uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/download_package_help.pdf'
  },
  dlhelp1: {
    name: 'download technical help',
    uri: 'https://rapids-static.s3-us-east-2.amazonaws.com/documents/download_technical_help.pdf'
  }
};

export const GetDocumentsURI = (name) => {
  if (window._env_?.CUI_APP) {
    return docs[name] ? (docs[name]?.cui_uri ? docs[name].cui_uri : docs[name].uri) : '';
  }
  return docs[name] ? docs[name].uri : '';
}

export const OpenDocumentsPage = (e, tag, target) => {
  if (e) {
    e.preventDefault();
  }
  if (tag) {
    let uri = GetDocumentsURI(tag);
    if (uri) {
      if (target){
        uri = uri.concat(target);
      }
      window.open(uri, '_blank').focus();
    }
  }
}

export const GotoDocumentsPage = (tag) => {
  if (tag) {
    let uri = GetDocumentsURI(tag);
    if (uri) {
      window.location.href = uri;
    }
  }
}

function DocumentsPage() {
  const { classes } = useStyles();
  let { name } = useParams();
  
  useEffect(() => {
    // console.log(name);
    if (name) {
      // Open document
      let uri = GetDocumentsURI(name);
      if (uri) {
        window.location.href =  uri;
      }
    }
  }, [name]);

  return (
    <div className='page-background'>
      <Container className='page-foreground'>
        <Row className='body-padding'>
          <h2><b>Documents</b></h2>
        </Row>
        
        <div className={classes.docList}>
          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'helpDoc')}>
              Help Document and AWS Guide
            </a>
          </Row>

          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'ddValidationDoc')}>
              Data Dictionary Validation
            </a>
          </Row>

          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'wearableDDEx')}>
              Wearable Data Dictionary Example
            </a>
          </Row>

          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'surveyDDEx')}>
              Survey Data Dictionary Example
            </a>
          </Row>

          <Row>
            <a href={'/'} onClick={(e) => OpenDocumentsPage(e, 'harmonizedDDEx')}>
              Harmonized Data Dictionary Example
            </a>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default (DocumentsPage);